module.exports = __webpack_public_path__ + "img/ofd.934d6e5b.svg";